import { render, staticRenderFns } from "./OzWallListRow.vue?vue&type=template&id=3209c5b5&"
import script from "./OzWallListRow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzWallListRow.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports